/* eslint-disable */ 
import {TOKEN, AUTH_USER_ID} from '../constant';

export default {
    state: { 
        login: {
            loading: false,
            statusOk: true,
            errMessage: ""
        },
        register: {
            loading: false,
            statusOk: true,
            okMessage: "",
            errMessage: ""
        }
    },
    mutations: {
        'LOGIN_LOADING': (state, val) => {
            state.login.loading = val;
        },
        'LOGIN_SUCCESS': (state, val) => {
            state.login.statusOk = true;
            state.login.errMessage = "";
            axios.defaults.headers.common['Authorization'] = "Bearer "+val.token;
            localStorage.setItem(TOKEN, val.token);
            localStorage.setItem(AUTH_USER_ID, val.user._id);
            window.location.href = "/";
        },
        'LOGIN_ERROR': (state, val) => {
            state.login.statusOk = false;
            state.login.errMessage = val;
            axios.defaults.headers.common['Authorization'] = "";
            localStorage.setItem(TOKEN, "");
            localStorage.setItem(AUTH_USER_ID, "");
        },
        'LOGIN_REGISTERING': (state, val) => {
            state.register.loading = val;
        },
        'LOGIN_REGISTER_SUCESS': (state, val) => {
            state.register.statusOk = true;
            state.register.okMessage = val;
            state.register.errMessage = "";
        },
        'LOGIN_REGISTER_ERROR': (state, val) => {
            state.register.statusOk = false;
            state.register.okMessage = "";
            state.register.errMessage = val;
        }
    },
    actions: {
        'LOGIN': ({commit, rootState}, payload) => {
            commit('LOGIN_LOADING', true);
            axios.post('/login', payload)
                .then(resp => {
                    commit('LOGIN_LOADING', false);
                    commit('LOGIN_SUCCESS', resp.data.response);
                    console.log(resp);
                })
                .catch(err => {
                    commit('LOGIN_LOADING', false);
                    commit('LOGIN_ERROR', rootState.locale === "en" ? "Login failed. Check email/password and try again.":"Sisäänkirjautuminen epäonnistui. Tarkista kirjautumistiedot ja yritä uudelleen.");
                    console.log(err.response);
                });
        },
        'LOGIN_REGISTER': ({commit, rootState}, payload) => {
            return new Promise(resolve => {
                commit('LOGIN_REGISTERING', true);
                axios.post('/user', payload)
                .then(resp => {
                    commit('LOGIN_REGISTERING', false);
                    commit('LOGIN_REGISTER_SUCESS', rootState.locale === "en" ? 'Registration successful. Please check your email and verify your registration.':'Rekisteröityminen onnistui. Tarkista sähköpostisi vahvistaaksesi rekisteröitymisen.');
                    console.log(resp);
                    resolve();
                })
                .catch(err => {
                    commit('LOGIN_REGISTERING', false);
                    const errTxt = err.response ? (err.response.data ? (err.response.data.errTxt ? err.response.data.errTxt : undefined): undefined) : undefined;
                    commit('LOGIN_REGISTER_ERROR', err.response.status === 409 ? (rootState.locale === "en" ? "Email is already in use. Please use different email or goto forgot password.":"Sähköpostiosoite on jo käytössä. Käytä toista sähköpostia tai paina unohditko salasanasi."):(errTxt ? errTxt : 'Error. Server Error'));
                    console.log(err.response);
                });
            });
        }
    }
}